<template>
  <modal name="service-presets" height="auto" :width="620" :adaptive="true" @before-open="onOpen">
    <div class="p-4 service-preset-modal">
      <h5 class="mb-3">Preset Countdown</h5>
      <p class="small text-muted">Preset global — durasi atau hitung mundur ke jam tertentu. Switch cepat dari toolbar.</p>

      <div v-for="(preset, idx) in form" :key="preset.id" class="service-preset-modal__card">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong>{{ preset.name || `Countdown ${idx + 1}` }}</strong>
          <label class="small mb-0">
            <input v-model="preset.autoStart" type="checkbox" class="mr-1" />
            Auto-start saat switch
          </label>
        </div>
        <div class="form-group mb-2">
          <label class="small text-muted mb-0">Nama</label>
          <input v-model="preset.name" class="form-control form-control-sm" @input="syncLabels(preset)" />
        </div>
        <div class="form-group mb-2">
          <label class="small text-muted mb-0">YouTube URL / Live</label>
          <input v-model="preset.youtubeUrl" class="form-control form-control-sm" placeholder="https://youtube.com/..." />
        </div>
        <div class="row">
          <div class="col-6 form-group mb-2">
            <label class="small text-muted mb-0">Label countdown</label>
            <input v-model="preset.tMinusLabel" class="form-control form-control-sm" />
          </div>
          <div class="col-6 form-group mb-2">
            <label class="small text-muted mb-0">Mode</label>
            <select v-model="preset.tMinusMode" class="form-control form-control-sm">
              <option value="duration">Durasi</option>
              <option value="wallclock">Jam tertentu</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div v-if="preset.tMinusMode !== 'wallclock'" class="col-6 form-group mb-2">
            <label class="small text-muted mb-0">Durasi (menit)</label>
            <input
              :value="Math.round((preset.tMinusDuration || 600) / 60)"
              type="number"
              min="1"
              class="form-control form-control-sm"
              @input="preset.tMinusDuration = Math.max(60, Number($event.target.value) * 60 || 600)"
            />
          </div>
          <div v-else class="col-6 form-group mb-2">
            <label class="small text-muted mb-0">Target (HH:MM)</label>
            <input v-model="preset.tMinusTargetTime" type="time" class="form-control form-control-sm" />
          </div>
        </div>
        <div class="form-group mb-1">
          <div class="d-flex justify-content-between align-items-center">
            <label class="small text-muted mb-0">Alert connector (T−)</label>
            <label class="small text-muted mb-0 d-flex align-items-center">
              Hilang
              <input
                v-model.number="preset.alertAutoClose"
                type="number"
                min="1"
                max="30"
                class="form-control form-control-sm ml-1 service-preset-modal__secs"
              />
              <span class="ml-1">dtk</span>
            </label>
          </div>
        </div>
        <div
          v-for="(cue, ci) in preset.alertCues"
          :key="`${preset.id}-cue-${ci}`"
          class="service-preset-modal__cue"
        >
          <input
            :value="formatCueAt(cue.at)"
            class="form-control form-control-sm service-preset-modal__at"
            placeholder="1:00"
            @change="setCueAt(preset, ci, $event.target.value)"
          />
          <input v-model="cue.message" class="form-control form-control-sm" placeholder="Pesan alert" />
          <button type="button" class="btn btn-sm btn-outline-secondary" title="Hapus cue" @click="removeCue(preset, ci)">
            <i class="fas fa-times" />
          </button>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary mt-1" @click="addCue(preset)">
          + Cue
        </button>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-light mr-2" @click="$modal.hide('service-presets')">Batal</button>
        <button type="button" class="btn btn-primary" :disabled="saving" @click="save">
          {{ saving ? 'Menyimpan...' : 'Simpan' }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'
import {
  defaultCueMessage,
  formatCueAt,
  normalizeGlobal,
  parseCueAt,
} from '@/widgets/servicePresets'

export default {
  data() {
    return {
      form: [],
      saving: false,
    }
  },
  methods: {
    ...mapActions('workspace', ['updateServicePresets']),
    formatCueAt,
    onOpen(event) {
      const global = event?.params?.global || {}
      const normalized = normalizeGlobal(global)
      this.form = normalized.servicePresets.map((p) => ({
        ...p,
        alertCues: (p.alertCues || []).map((c) => ({ ...c })),
      }))
    },
    syncLabels(preset) {
      if (!preset.timerLabel || preset.timerLabel.startsWith('Ibadah') || preset.timerLabel.startsWith('Countdown')) {
        preset.timerLabel = preset.name
      }
      if (!preset.tMinusLabel || preset.tMinusLabel.startsWith('Ibadah') || preset.tMinusLabel.startsWith('Countdown')) {
        preset.tMinusLabel = preset.name
      }
    },
    setCueAt(preset, idx, raw) {
      const at = parseCueAt(raw)
      const cue = preset.alertCues[idx]
      if (!cue) return
      const prev = defaultCueMessage(cue.at)
      cue.at = at
      if (!cue.message || cue.message === prev) {
        cue.message = defaultCueMessage(at)
      }
    },
    addCue(preset) {
      if (!Array.isArray(preset.alertCues)) preset.alertCues = []
      preset.alertCues.push({ at: 60, message: defaultCueMessage(60) })
    },
    removeCue(preset, idx) {
      preset.alertCues.splice(idx, 1)
    },
    async save() {
      this.saving = true
      try {
        await this.updateServicePresets(this.form)
        this.$modal.hide('service-presets')
        this.$toast?.success?.('Preset countdown disimpan')
      } catch (e) {
        this.$toast?.error?.(e.message || 'Gagal menyimpan')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.service-preset-modal__card {
  border: 1px solid var(--ws-panel-border, #dee2e6);
  border-radius: 8px;
  padding: 0.75rem;
  margin-bottom: 0.75rem;
  background: var(--ws-bg-subtle, #f8f9fa);
}
.service-preset-modal__cue {
  display: flex;
  gap: 0.4rem;
  align-items: center;
  margin-top: 0.35rem;
}
.service-preset-modal__at {
  width: 72px;
  flex: 0 0 72px;
}
.service-preset-modal__secs {
  width: 56px;
  display: inline-block;
}
</style>
